import React from 'react';
import ReactDOM from 'react-dom';

import './i18n';
import { Provider } from 'react-redux';
import { App } from './app';
import reportWebVitals from './reportWebVitals';
import { ErrorBoundary } from './ui/ErrorBoundary';
import { store } from './utils/redux_store/store';

ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Provider store={store}>
        <App />
      </Provider>
    </ErrorBoundary>
  </React.StrictMode>,
  document.getElementById('root'),
);
reportWebVitals();
